import { Theme } from '@mui/material/styles';

export const main = (theme: Theme) => ({
    paddingTop: theme.spacing(10.625),
    marginTop: theme.spacing(7.5),
    minHeight: `calc(100vh - ${theme.footerHeight} - ${theme.headerHeight} - 70px)`,
}) as const;

export const box = (theme: Theme) => ({
    marginBottom: theme.spacing(3),
    maxWidth: '700px',
}) as const;

export const title = (theme: Theme) => ({
    fontSize: '1.125rem !important',
    fontWeight: 700,
    marginBottom: theme.spacing(1.75),
}) as const;
